import React, {PureComponent} from 'react';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {withTranslation} from 'react-i18next';
import {differenceBy} from 'lodash';
import Select from 'react-select';
import {store} from "../AppRenderer";

class DocumentFilterForm extends PureComponent {
  constructor(props) {
    super(props);
    this.options = [
      ...store.getState().app.kycItems.map(item => ({
        value: item.name, label: props.t(item.name)
      })),
    ];
  }

  getOptions = injectItems => {
    return differenceBy(this.options, injectItems, 'value');
  };

  getInitialItems = value => {
    const {t} = this.props;
    return value.split(',').map(item => ({
      label: t(item), value: item
    }));
  };
  
  onFilter = values => {
    const {items} = values;
    const {onChange} = this.props;
    onChange(items.map(item => item.value).join(','));
    ModalManager.close({
      isOpen: false
    });
  };
  
  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
    />
  );
  
  render() {
    const {t, filter} = this.props;
    return (
      <FinalForm
        onSubmit={this.onFilter}
        initialValues={{items: filter ? this.getInitialItems(filter.value) : undefined}}
        render={({handleSubmit, submitting, pristine, values}) => {
          return (
            <Form>
              <Row>
                <Col>
                  <Field
                    name="items"
                    options={this.getOptions(values.items)}
                    component={this.ReactSelectAdapter}
                    closeMenuOnSelect={false}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <LoaderButton
                    color="success"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={pristine || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}>
                    {t('Filter')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(DocumentFilterForm);